(function () {
	'use strict';

	// ─── Smooth scroll (Lenis) ──────────────────────────────────────────────────
	// Ported from the luigetiigi site. Lenis runs on GSAP's ticker so ScrollTrigger
	// (animate-words.js) stays in sync with the smoothed position. Off in the
	// Elementor editor preview (no html.arelis-motion) and with reduced motion.
	// The instance is window.arelisLenis (stop() / start() it around scroll locks).

	function headerOffset() {
		var header = document.querySelector('[data-elementor-type="header"]');
		return header ? header.getBoundingClientRect().height : 0;
	}

	document.addEventListener('DOMContentLoaded', function () {
		if (!window.Lenis || !document.documentElement.classList.contains('arelis-motion')) {
			return;
		}
		if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
			return;
		}

		var lenis = new window.Lenis({
			duration: 1.2,
			// Scrollable boxes (practice nav, search results, team row) scroll natively
			allowNestedScroll: true,
			// So does everything inside the search <dialog>
			prevent: function (node) {
				return node.nodeName === 'DIALOG';
			},
		});
		window.arelisLenis = lenis;

		if (window.gsap && window.ScrollTrigger) {
			lenis.on('scroll', window.ScrollTrigger.update);
			window.gsap.ticker.add(function (time) {
				lenis.raf(time * 1000);
			});
			window.gsap.ticker.lagSmoothing(0);
		} else {
			var raf = function (time) {
				lenis.raf(time);
				requestAnimationFrame(raf);
			};
			requestAnimationFrame(raf);
		}

		// In-page anchors glide too, landing below the sticky header. Lenis's own
		// `anchors` option ignores preventDefault, so it would also hijack #otsing
		// (search.js), which this listener leaves alone.
		document.addEventListener('click', function (event) {
			if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
				return;
			}
			var link = event.target.closest('a[href*="#"]');
			if (!link || link.origin !== location.origin || link.pathname !== location.pathname || link.hash.length < 2) {
				return;
			}
			var target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
			if (!target) {
				return;
			}
			event.preventDefault();
			lenis.scrollTo(target, { offset: -headerOffset() });
			history.pushState(null, '', link.hash);
		});
	});

})();
